export const paymentEndpoints = {
    charge: {
        add: {
            api: '/api/order/sales/cc/payment',
            method: 'POST',
            parameter: false
        }
    },
    chargeAdyen: {
        add: {
            api: '/api/order/sales/cc/payment/v2',
            method: 'POST',
            parameter: false
        }
    }

};


// WEBPACK FOOTER //
// ./src/endpoints/payment.endpoints.ts